import FlightBackAndFroth from "./FlightBackAndFroth";
import SpecialFlight from "./SpecialFlight";
import ContinerPrice from "./ContinerPrice";


export default function FlightContiner ({data, dataFlightCar, setDataFlightCar, type, special}) {
    const head5 = ["שם", "מס' טיסה", "תאריך", "יום", "מיקום", "יעד", "המראה", "נחיתה", "מזוודה", "טרולי", "סכום"];

    function click_select_flight (nameFlight) {
        let number = type !== 1 ? type : nameFlight[1].startsWith('A') ? 2 : 3; // check on special flight, if it's an outbound or return flight
        if (type === 2 || type === 3 || type === 1) {
            // if the updated is a round flight , delete the outbound and the return
            dataFlightCar['fa'][1] && dataFlightCar['fa'][1].startsWith('B') && setDataFlightCar({...dataFlightCar, fa: [], fr: []});
            let selected = number === 2 ? dataFlightCar['fa'][1] === nameFlight[1] : dataFlightCar['fr'][1] === nameFlight[1]; // check if the updated flight and insert flight same,
            if (! selected) {
                number === 2 ? setDataFlightCar(dataFlightCar => {return{...dataFlightCar, fa: nameFlight}}) : setDataFlightCar(dataFlightCar => {return {...dataFlightCar, fr: nameFlight} });
            } else {
                number === 2 ? setDataFlightCar({...dataFlightCar, fa: []}) : setDataFlightCar({...dataFlightCar, fr: []});
            }
        } else if (type === 4) {
            let selected = dataFlightCar['fa'][1] === nameFlight['A'][1];
            (! selected) ? setDataFlightCar({...dataFlightCar, fa: nameFlight['A'], fr: nameFlight['R']}) : setDataFlightCar({...dataFlightCar, fa: [], fr: []});
        }
    }

    return (<>
        {data && type === 1 ? 
            <SpecialFlight data={data} click_select_flight={click_select_flight} specialTime={special} /> :

            <table className="aufaTable">

                <thead>
                    <tr>
                        {
                            head5.map((value, key) => <td key={key}> {value} </td>)
                        }
                    </tr>
                </thead>

                <tbody>
                    { type !== 4 ? 
                    data.map((data_flight, keyH) => {
                        let flight = data_flight['flight'].slice(2, -1);

                        return (
                        <tr key={keyH} onDoubleClick={(e) => click_select_flight([data_flight['key'], ...flight, data_flight['price']])} >
                            {
                                flight.map((value, key) => <td key={key}> {value} </td>)
                            }
                            <td>
                                <ContinerPrice 
                                price={data_flight['price']}
                                r_price={data_flight['r_price']}
                                places={data_flight['places']}
                                />
                            </td>
                        </tr>
                        ) }) :

                    <FlightBackAndFroth data={data} click_select_flight={click_select_flight} />
                }
                </tbody>
            </table>
        }
    </>)
}